import React from 'react';

import { CustomerProvidedVariablesContainer } from '../../portfolio/ui/customerProvidedVariables/CustomerProvidedVariablesContainer';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';

export const BorrowerCustomerProvidedVariables = () => {
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <CustomerProvidedVariablesContainer creditFacilityId={creditFacilityId} />
  );
};
